import * as React from 'react';
import { useContext, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import * as Styled from './styled';
import { RootStoreContext } from '../../App';
import MatterContainer from './MatterContainer';

const Matters = () => {
    const { t } = useTranslation(['matters']);
    const rootStore = useContext(RootStoreContext);
    const matterLabel = rootStore.appStore.features.EpochConfigMatterLabel;
    const {
        availableClientMattersTuple,
        trackedClientMattersTuple,
        fetchMoreAvailMatters,
        fetchMoreTrackedMatters,
        selectedMatters,
        setSelectedMatters,
        track,
        untrack,
        loadingAvailable,
        loadingTracked,
        searchTrackedText,
        searchAvailableText,
        setTrackedSearchText,
        setAvailableSearchText,
        loadTrackedMatters,
        loadAvailableMatters
    } = rootStore.mattersStore;

    useEffect(() => {
        setAvailableSearchText('');
        setTrackedSearchText('');
        loadTrackedMatters();
        loadAvailableMatters('', false);
    }, []);

    const _untrack = (ids: number[]) => {
        if (confirm(t('left_panel.list.row.icon.dialog.message.online', { matterLabel }))) {
            untrack(ids);
        } else {
            return;
        }
    }
    const searchTrackedMatters = (val: string) => {
        setTrackedSearchText(val);
    }
    const searchAvailableMatters = (val: string) => {
        setAvailableSearchText(val);
        loadAvailableMatters(val, false);
    }

    return (
        <Styled.MainWrapper container={true}>
            <Styled.WrapperItem xs={12} sm={6}>
                <MatterContainer
                    title={t('left_panel.header.search.tooltip', { matterLabel })}
                    matters={trackedClientMattersTuple}
                    fetchMore={fetchMoreTrackedMatters}
                    isTrackedList={true}
                    selected={selectedMatters}
                    onSelect={setSelectedMatters}
                    untrack={_untrack}
                    loading={loadingTracked}
                    search={searchTrackedText}
                    onInputChange={searchTrackedMatters}
                />
            </Styled.WrapperItem>
            <Styled.WrapperItem xs={12} sm={6}>
                <MatterContainer
                    title={t('right_panel.header.search.tooltip', { matterLabel })}
                    matters={availableClientMattersTuple}
                    fetchMore={fetchMoreAvailMatters}
                    isTrackedList={false}
                    selected={selectedMatters}
                    onSelect={setSelectedMatters}
                    track={track}
                    untrack={_untrack}
                    loading={loadingAvailable}
                    search={searchAvailableText}
                    onInputChange={searchAvailableMatters}
                />
            </Styled.WrapperItem>
        </Styled.MainWrapper>
    );
}

export default observer(Matters);